exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Row-module__grid___2yroS{display:grid;gap:.5em;z-index:1;background-color:#fff;padding:5px;border-radius:10px}.Row-module__grid___2yroS .Row-module__wrapper___2qQ_A{display:grid;gap:4px;justify-content:center}.Row-module__grid___2yroS .Row-module__wrapper___2qQ_A.Row-module__large-icon___1KFeq input,.Row-module__grid___2yroS .Row-module__wrapper___2qQ_A.Row-module__large-icon___1KFeq svg{font-size:18px}", ""]);

// exports
exports.locals = {
	"grid": "Row-module__grid___2yroS",
	"wrapper": "Row-module__wrapper___2qQ_A",
	"large-icon": "Row-module__large-icon___1KFeq"
};